import { Modal } from '../Modal/Modal';
import { FollowUpBoard } from './FollowUpBoard';
import CheckImg from '../../assets/check.svg';
import CrossImg from '../../assets/smallCross.svg';
import { Button } from '@blueprintjs/core';

import styles from './FollowUpModal.module.css';

type FollowUpModalProps = {
  onClose: () => void;
  onSubmit?: () => void;
};

export const FollowUpModal = ({ onClose, onSubmit }: FollowUpModalProps) => {
  const ModalHeader = (
    <div className={styles.followUpModalTitle}>
      <div className={styles.followUpModalTitle__content}>
        <img src={CheckImg} alt="Check" /> Set follow-up
      </div>
      <Button
        icon={<img src={CrossImg} alt="Close" />}
        variant="minimal"
        onClick={onClose}
      />
    </div>
  );

  return (
    <Modal onClose={onClose} title={ModalHeader}>
      <FollowUpBoard onSubmit={onSubmit} />
    </Modal>
  );
};
